var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Radio } from '../Radio/Radio';


var TermsCheckbox = /** @class */ (function (_super) {
    __extends(TermsCheckbox, _super);
    function TermsCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TermsCheckbox.prototype.render = function () {
        var _a = this.props, missing = _a.missing, accepted = _a.accepted, onChange = _a.onChange, onTermsClick = _a.onTermsClick, onPrivacyPolicyClick = _a.onPrivacyPolicyClick;
        var classes = "pluggy terms-checkbox";
        if (!accepted && missing) {
            classes += " missing";
        }
        return (React.createElement("div", { className: classes },
            React.createElement(Radio, { onChange: onChange, checked: accepted }),
            React.createElement("div", { className: "terms-text" },
                "Li e aceito os ",
                React.createElement("a", { onClick: onTermsClick }, "Termos e condi\u00E7oes de uso"),
                ' ',
                "e",
                ' ',
                React.createElement("a", { onClick: onPrivacyPolicyClick, className: "link" }, "Pol\u00EDtica de privacidade."))));
    };
    TermsCheckbox.defaultProps = {
        accepted: false,
        missing: false,
    };
    return TermsCheckbox;
}(React.PureComponent));
export { TermsCheckbox };
